import React from 'react';

const Skills = () => {
    const skills = [
        { name: 'Core PHP', percent: '90%', color: 'color-1' },
        { name: 'Laravel', percent: '95%', color: 'color-1' },
        { name: 'Codeigniter', percent: '90%', color: 'color-1' },
        { name: 'jQuery', percent: '90%', color: 'color-2' },
        { name: 'HTML5', percent: '100%', color: 'color-3' },
        { name: 'CSS3', percent: '95%', color: 'color-4' },
        { name: 'MySQL', percent: '90%', color: 'color-5' },
        { name: 'PgSQL', percent: '80%', color: 'color-6' },
        { name: 'React Js', percent: '80%', color: 'color-6' },
        { name: 'Node Js', percent: '80%', color: 'color-6' },
        { name: 'Kubernetes', percent: '75%', color: 'color-1' },
        { name: 'Monitoring Tools', percent: '80%', color: 'color-2' },
        { name: 'Docker', percent: '85%', color: 'color-3' },
        { name: 'CI/CD', percent: '85%', color: 'color-4' },
        { name: 'AWS', percent: '80%', color: 'color-5' },
        { name: 'Terraform', percent: '75%', color: 'color-6' },
        { name: 'Linux', percent: '90%', color: 'color-1' },
        { name: 'Reverse Proxy', percent: '80%', color: 'color-2' },
    ];

    return (
        <section className="ftco-section" id="skills-section">
            <div className="container">
                <div className="row justify-content-center pb-5">
                    <div className="col-md-12 heading-section text-center" data-aos="fade-up">
                        <h1 className="big big-2">Skills</h1>
                        <h2 className="mb-4">My Skills</h2>
                        <p>
                            Advanced proficiency in backend engineering, cloud-native infrastructure, DevOps automation, and modern web technologies — focused on performance optimization, scalability, and clean architecture.
                        </p>
                    </div>
                </div>
                <div className="row">
                    {skills.map((skill, index) => (
                        <div className="col-md-6 animate-box" key={index} data-aos="fade-up" data-aos-delay={index * 50}>
                            <div className="progress-wrap ftco-animate">
                                <h3>{skill.name}</h3>
                                <div className="progress">
                                    <div className={`progress-bar ${skill.color}`} role="progressbar" aria-valuenow={parseInt(skill.percent)}
                                        aria-valuemin="0" aria-valuemax="100" style={{ width: skill.percent }}>
                                        <span>{skill.percent}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default Skills;
